export enum AppMode {
  Embedded = 'embedded',
  Standalone = 'standalone',
}
